import View from "ln/view/View";
import Node from "ln/node/Node";
import VideoPlayer from '../VideoPlayer';

class VolumeBar extends View{

    private dragStartX:number;
    private dragEndX:number;

    constructor( public player:VideoPlayer ){
        super();

        this.defaultTemplate = 'lv.video-volume';

        this.player.volume.add( this.update, this );
    }

    public init(){
        this.node.js( 'clickhandler' ).click.add( this.changeVolume, this );
        /*this.node.js( 'dot' ).mousedown.add( this.startDrag, this );
        this.node.js( 'dot' ).mouseup.add( this.stopDrag, this );*/
    }

    protected renderData(){
        return {
            volume: this.player.video.volume * 100
        };
    }

    private changeVolume( n:Node, e:MouseEvent ){
        this.player.video.volume = ( e.offsetX / n.bounds().width );
    }

    private update( volume:number ){
        let v = volume * 100;
        this.node.js( 'current' ).style.width = v + '%';
        this.node.js( 'dot' ).style.left = v + '%';
    }

}

export default VolumeBar;